import React, { forwardRef, useImperativeHandle, useState, useEffect, useContext } from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import ALoader from 'views/pages/manage/common/a-loader';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { Tooltip } from '@mui/material';
import { GridRowModes } from "@mui/x-data-grid";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
//import StatusCellComponent from "./StatusCellComponent";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { checkDuplicateEntry, newRow } from './constant';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import AInput from '../../../../manage/common/formFeilds/customInput/AInput';
import { editCellContainerStyle } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import { inputStyles, selectStyles } from '../../holidayMaster/common';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ActionsCellComponent from './ActionCellComponent';
import { pages, regex } from '../../../../manage/common/constant';
import { RolePermissions } from 'appContext';
import { PermissionContext } from 'appContext';
import moment from 'moment';
import { maskEmail, maskPhoneNumber } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/paymentLink/utils';
const ListComponent = forwardRef(
    ({ currentPage = 0,
        rowCount,
        dropdown,
        rows = [],
        loader,
        createHandler,
        updateHandler,
        rowForm,
        setRowForm
    }, ref) => {
        const [rowModesModel, setRowModesModel] = useState({});
        const [rowData, setRowData] = useState(rows);
        const userPermissions = RolePermissions(
            useContext(PermissionContext),
            pages["schoolMaster"]["id"]
        );
        useEffect(() => setRowData(rows), [rows]);
        const rowFormHandler = (value, key) => setRowForm((prev) => ({ ...prev, [key]: value }));

        const startEditing = (id, form) => {
            setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
            setRowForm(form);
        };

        const stopEditing = () => {
            const currForm = { ...rowForm };
            setRowModesModel((oldModel) => ({ [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true } }));
            setRowForm({});
        };

        const handleEditClick = (params) => {
            if (!isObjEmpty(rowForm)) {
                failureToast(saveOrDeleteMsg);
            } else {
                startEditing(params?.id, params?.row);
            }
        };

        const handleCancelClick = async (params) => {
            if (params?.row?.isNew) {
                setRowData(rows)
                setRowForm({});
            }
            else {
                stopEditing(params?.id)
            }
        }

        const handleSaveClick = async (params) => {
            const nonEditModeRows = rows.filter(item => item?.id !== rowForm?.id);
            let emailRegex = regex?.email;
            if (!emailRegex.test(rowForm?.email)) {
                failureToast("Please enter valid email");
                return;
            }
            else if ((rowForm?.contact).length != 10) {
                failureToast("Please enter a valid contact of 10 digits");
                return;
            }
            else if (checkDuplicateEntry(nonEditModeRows, rowForm, 'contact')) {
                failureToast("Duplicate contact is not allowed");
                return;
            }

            else {
                if (rowForm?.isNew) {
                    await createHandler(rowForm)
                } else {
                    await updateHandler(rowForm)
                }
            }
        }

        const addNewRow = async () => {
            if (!isObjEmpty(rowForm)) {
                failureToast(saveOrDeleteMsg);
            } else {
                let randomId = generateRandomId();
                let emptyRow = {
                    ...newRow,
                    isNew: true,
                    id: randomId,
                };
                startEditing(randomId, emptyRow);
                setRowData((prev) => [emptyRow, ...prev]);
            }
        };
        useImperativeHandle(ref, () => ({
            addNewRow: addNewRow,
            startEditing: startEditing,
            stopEditing: stopEditing
        }))


        const columns = [
            new AGridColDef("seqId", "Sr No.", false)
                .setMinWidth(50)
                .editable(true)
                .setFlex(0.5)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("name", "Name", false)
                .setMinWidth(100)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                ))
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AInput
                            placeholder='Enter'
                            value={rowForm?.name}
                            style={inputStyles}
                            regex={regex?.alphaNumericWithSpaceAndUnderscore}
                            handler={(value) => {
                                rowFormHandler(value, 'name')
                            }}
                        />
                    </div>
                )),
            new AGridColDef("jobTitle", "JobTitle", false)
                .setMinWidth(100)
                .editable(true)
                .setFlex(1.2)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip> : <div>-</div>
                ))
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.jobTitle}
                            handleChange={value => rowFormHandler(value, 'jobTitle')}
                            items={dropdown?.jobTitle}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                )),
            new AGridColDef("contact", "Contact", false)
                .setMinWidth(100)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={''}>
                        <div className={`ellipsis-text-container`}>{maskPhoneNumber(params?.value)}</div>
                    </Tooltip> : <div>-</div>
                ))
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AInput
                            placeholder='Enter'
                            value={rowForm?.contact}
                            style={inputStyles}
                            regex={regex?.numeric}
                            maxLength={10}
                            handler={(value) => {
                                rowFormHandler(value, 'contact')
                            }}

                        />
                    </div>
                )),
            new AGridColDef("type", "Type", false)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1.5)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip> : <div>-</div>
                ))
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.type}
                            handleChange={value => rowFormHandler(value, 'type')}
                            items={dropdown?.jobType}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                )),
            new AGridColDef("department", "Department.", false)
                .setMinWidth(50)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip> : <div>-</div>
                ))
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.department}
                            handleChange={value => rowFormHandler(value, 'department')}
                            items={dropdown?.department}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                )),
            new AGridColDef("email", "Email", false)
                .setMinWidth(100)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={maskEmail(params?.value)}>
                        <div className={`ellipsis-text-container`}>{maskEmail(params?.value)}</div>
                    </Tooltip> : <div>-</div>
                ))
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AInput
                            placeholder='Enter'
                            value={rowForm?.email}
                            style={inputStyles}
                            // regex={regex?.email}
                            handler={(value) => {
                                rowFormHandler(value, 'email')
                            }}

                        />
                    </div>
                )),
            new AGridColDef("updatedOn", "Updated On", false)
                .setMinWidth(130)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')} by ${params?.row?.updatedBy}`}>
                        <div className={`ellipsis-text-container`}>{`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')} by ${params?.row?.updatedBy}`}</div>
                    </Tooltip> : <div>-</div>
                )),
            ...(userPermissions?.includes("C") || userPermissions?.includes("U")
                ? [new AGridColDef("action", "Action", false)
                    .setMinWidth(180)
                    .setFlex(2)
                    .columnAlign('right')
                    .renderCellComponent((params) => (
                        <ActionsCellComponent
                            params={params}
                            handleEditClick={handleEditClick}
                            handleCancelClick={handleCancelClick}
                            handleSaveClick={handleSaveClick}
                            rowForm={rowForm}
                            disable={!(rowForm?.name && rowForm?.jobTitle && rowForm?.contact && rowForm?.type && rowForm?.department && rowForm?.email)}
                        // deleteHandler={deleteHandler}
                        />

                    ))] : []),

        ]
        return (<>
            {loader ? <ALoader position="fixed" /> :
                <ADataGrid
                    removeWrapperContainer
                    rowModesModel={rowModesModel}
                    rows={rowData || []}
                    columns={columns}
                    rowId={(row) => row.id}
                    rowHeight={50}
                    loading={false}
                    rowCount={rowCount}
                    // nextButtonHandler={onPageChange}
                    currentPage={currentPage}
                    components={{
                        ...gridComponents,
                        NoRowsOverlay: () => (
                            <NoRowOverlay message={loader ? "Loading..." : null} />
                        ),
                    }}
                    sx={gridStyles}
                    autoHeight
                    hidePagination={true}
                />
            }
        </>
        );
    })
export default ListComponent